import { Component, Input, Output, OnInit, OnDestroy, EventEmitter, ViewChild } from '@angular/core';

import { UntypedFormGroup, UntypedFormControl, NgForm, Validators } from '@angular/forms';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

import { DecimalPipe } from '@angular/common';
import { Subscription } from 'rxjs';

import { TabitPayService } from 'src/app/tabit-pay/tabit-pay.service';
import { GeneralUtilsService } from 'src/app/_services/general.utils.service';
import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { ExpayService } from 'src/app/_services/expay.service';
import { appEnums } from 'src/app/_core/static/us-states';

import * as _ from 'lodash';

@Component({
    selector: 'app-tabitpay-checkout-pay',
    templateUrl: './tabitpay-checkout-pay.component.html',
    styleUrls: ['./tabitpay-checkout-pay.component.scss'],
    standalone: false
})
export class TabitpayCheckoutPayComponent implements OnInit, OnDestroy {
    @ViewChild('paymentForm') paymentForm!: NgForm;


	onlyCountries: String[] = [];

	public phoneForm;
	public contactForm;


    @Input() options;
    @Output() onPayment = new EventEmitter<any>();

	private orderSubscription: Subscription = null;
	private checkSubscription: Subscription = null;

    paymentMethods = ["creditCard", "Cibus", "10bis"];

	$storage: any;

    ui: any = {};
    ccinfo: any = this.getDefaultCCinfo;
    wallet: any;
    walletPm: any;
    step: any = 'alternatePayment';
	cache:any = {}

	closing: boolean = false;
	paying: boolean = false;
	hasGratuity: boolean = true;
	showPaymentTypes: boolean = true;
	usStates = appEnums.usStates;
	stateFormControl = new UntypedFormControl('', Validators.required);
	missingPM: boolean = false;
	maxCreditPayment: number = 0;
	wasMaxCreditPaymentActive: boolean = false;
    enableSaveToWallet: boolean = false;
	contacMode: boolean = false;

	constructor(
		public appService: AppService,
		public tabitPayService: TabitPayService,
		public dialogsService: DialogsService,
		public generalUtils: GeneralUtilsService,
		public expayService: ExpayService,
		public decimalPipe: DecimalPipe
	) {
		this.tabitPayService.createUserWalletPms();
		this.$storage = this.tabitPayService.$storage;

		if (['IL'].includes(this.appService.region) && !this.appService.user && (!localStorage.getItem("c_phone") || !localStorage.getItem("c_name"))) {
			this.contacMode = true;
			this.contactForm = new UntypedFormGroup({
				phone: new UntypedFormControl('', [Validators.required]),
				name: new UntypedFormControl('', [Validators.required]),
			});

		} else {
			this.init();
		}

	}

	applyContact() {
		if (!this.contactForm.valid) {
			this.contactForm.get("phone").markAsTouched({ onlySelf: true });
			this.contactForm.get("name").markAsTouched({ onlySelf: true });
		} else {
			const phone = this.contactForm.value.phone;
			if (!this.appService.isValidMobilePhone(phone)) return;
			localStorage.setItem('c_phone', phone);

			const name = this.contactForm.value.name;
			localStorage.setItem('c_name', name);
			this.contacMode = false;
			this.init();
		}

	}

	init() {
		let that = this;
        this.tabitPayService.fixGratuity();
		this.cache.balanceDue = this.$storage.order.balanceDue;
		this.cache.total = this.$storage.order.grandTotal;
		this.cache.grandTotalPlusTip = that.$storage.order.grandTotalPlusTip;
		this.cache.gratuity = that.$storage.order.gratuity;
		this.cache.isPartialPayment = that.$storage.order.isPartialPayment;
		this.hasGratuity = _.get(this.cache, 'gratuity.amount') > 0;

		this.phoneForm = new UntypedFormGroup({
			phone: new UntypedFormControl('', [Validators.required]),
		});

		if (!this.$storage.contact?.firstName && localStorage.getItem("c_name")) {
			this.$storage.contact.firstName = localStorage.getItem("c_name");
		}
		if (localStorage.getItem("c_phone")) this.phoneForm.setValue({ phone: localStorage.getItem("c_phone") });

		if (this.$storage.order.orderType != 'Seated') {
			if (!this.$storage.contact.firstName) {
				if (!this.$storage.check) {
					let _name = _.get(this.$storage.order.printData, 'variables.ORDERER_NAME');
					if (_name) {
						this.$storage.contact.firstName = _name;
					}
				}
			}
			if (!this.$storage.contact.phone) {
				if (!this.$storage.check) {
					const tel = _.get(this.$storage.order.printData, 'variables.ORDERER_TEL');
					if (tel) {
						this.$storage.contact.phone = tel.replace(/\D/g, '');
					}
				}
			}
		} else {
			if (this.appService.region == 'IL') this.maxCreditPayment = 1500;
		}

		// ----------------------------------------------------------------------->
		this.checkSubscription = this.tabitPayService.checkChanged$.subscribe(() => {
			if (that.closing) return;
			if (!that.paying) {
				that.appService.toastr('MESSAGES.PAY_ORDER_CHANGED', { type: 'info' });
				that.onPayment.emit({});
				return;
			}
		});

		this.orderSubscription = this.tabitPayService.orderChanged$.subscribe(() => {
			if (that.closing) return;
			if (this.$storage.restricted) {
				that.appService.toastr('MESSAGES.PAY_ORDER_CHANGED', { type: 'info' });
				that.onPayment.emit({});
				return;
			}

			let cache = that.cache;
			let order = that.$storage.order;

			let balanceDue = order.balanceDue;
			if (this.$storage.check) {
				const _check: any = _.find(this.$storage.order.checks, { _id: this.$storage.check._id });
				balanceDue = _check.$$balanceDue;
			}
			const total = order.grandTotal;

			const wasBalanceChanged = balanceDue != cache.balanceDue;
			const wasTotalChanged = total != cache.total;

			cache.balanceDue = balanceDue;
			order.isPartialPayment = cache.isPartialPayment;

			order.grandTotal = cache.total;
			order.gratuity = cache.gratuity;
			order.grandTotalPlusTip = cache.grandTotalPlusTip;
			this.tabitPayService.fixGratuity();

			if (!wasBalanceChanged) return;

			if (balanceDue === 0) {
				that.onPayment.emit({});
				return
			}

			if (!that.paying) {
				if (wasTotalChanged && (!cache.isPartialPayment  || cache.total > balanceDue)) {
					that.appService.toastr('MESSAGES.PAY_ORDER_CHANGED', { type: 'info' });
					that.onPayment.emit({});
					return;
				}
			}

		});

		// ----------------------------------------------------------------------->
		// prepare payments methods
		// ----------------------------------------------------------------------->

        var arr = [], arrEx = [];
        const storage = this.$storage;
        const order = storage.order;
        const disableGratuityCash = !storage.disableCashPayment && storage.enableGratuity && order.gratuityAmount && order.gratuityAmount != 0;
		const disableCash = storage.disableCashPayment || disableGratuityCash;
		const disableCredit = that.$storage.order.grandTotalPlusTip > 1000;

        _.each(storage.paymentAccounts, (pm) => {
            let sch = pm.schedule = null;
			if (!sch || storage.activeTimeslots[sch] !== false) {

				if (pm.paymentType != "cash" || !disableCash) {

					if (pm.paymentType == "CreditGuard" && this.expayService.showNativePaymentButtons(this.$storage) && this.$storage.rosConfig?.config?.settings?.tabitPayNativePaymentsOnly) {
						return;
					}
					if (pm.isExternal) pm.paymentType = 'external';
                    arr.push(pm);
                    if (pm.paymentType == "cash") that.ui.cashMethod = pm;
				}
            };
		});

		const bitIndex = _.findIndex(arr, { paymentType: "Meshulam" });
		if (bitIndex != -1) {
			const bitPM = arr[bitIndex];
			arr.splice(bitIndex, 1);
			arr.unshift(bitPM);
		}

		this.ui.paymentMethods = arr;
		//if (this.appService.region == 'US') this.ui.paymentMethods = arr.concat(arrEx);
		//this.ui.exPaymentMethods = arrEx;

		const n = this.ui.paymentMethods.length;
		if (n) {
			if (n == 1 && this.ui.paymentMethods[0].paymentType == 'Braintree') {
				this.showPaymentTypes = false;
			}
			const selectedPm = this.ui.paymentMethods[0];
			if (this.appService.region != 'IL' || !disableCredit || selectedPm.paymentType != 'creditCard') {
				//this.setPaymentMethod(this.ccinfo, this.ui.paymentMethods[0], true);
			}
        }

		// ------------------------------------------------------------------------------------------------->
		// wallet
		// ------------------------------------------------------------------------------------------------->

		const userWallet = _.get(this.$storage, 'wallet');
		if (userWallet) {
			this.step = 'general';
			const wallet = this.$storage.wallet;
			if (!wallet.defaultCCinfo) {
				wallet.defaultCCinfo = wallet.ccinfo;
			} else {
				wallet.ccinfo = wallet.defaultCCinfo;
			}
			const _ccinfo = wallet.ccinfo;
			if (!this.checkWalletPaymentByAccount(wallet.ccinfo, true)) {
				delete wallet.ccinfo;
				for (var i = 0; i < wallet.pms.length; i++) {
					let _pm = wallet.pms[i];
					if (_pm == _ccinfo) continue;
					if (this.checkWalletPaymentByAccount(_pm, true)) {
						wallet.ccinfo = _pm;
						break;
					}
				}
				if (!wallet.ccinfo) {
					this.step = 'alternatePayment';
				}
			}
			if (wallet.ccinfo) this.walletPm = wallet.ccinfo;
		}

		if (['IL'].includes(this.appService.region)) {
			setTimeout(() => {
				// We need to pass the class name in order to preserve the generic ability to append
				// the buttons for Tabit Pay and GCS also
				this.appendApplePayButton('.apple-pay-button-wrapper');
				this.expayService.appendGooglePayButton('.google-pay-button-wrapper');
			}, 250);
		}

		if (this.step == 'alternatePayment' && this.ui.paymentMethods.length == 1 && !this.expayService.showNativePaymentButtons(this.$storage)) {
			this.setPaymentMethod(this.ccinfo, this.ui.paymentMethods[0]);
		}

    }

	ngOnInit() {

	}

	ngOnDestroy() {
		if (this.orderSubscription) this.orderSubscription.unsubscribe();
		if (this.checkSubscription) this.checkSubscription.unsubscribe();
	}

	// --------------------------------------------------------------------->
	// gift cards
	// --------------------------------------------------------------------->

	setWalletPayment(pm) {
		if (!this.checkWalletPaymentByAccount(pm)) return;
		this.$storage.wallet.ccinfo = this.walletPm = pm;
		this.ccinfo = { type: undefined };
		this.step = 'general';
	}

	alertMaxCreditPayment() {
		if (!this.wasMaxCreditPaymentActive) {
			this.appService.logTemplate('maxCreditPayment', {
				"paymentAmount": this.cache.grandTotalPlusTip,
				"tipAmount": _.get(this.cache, 'gratuity.amount', 0),
			});
			this.wasMaxCreditPaymentActive = true;
		}
		return this.appService.alert({ content: 'MESSAGES.PAYMENT_ABOVE_CREDIT_MAX', "confirmText": "GOT_IT" });
	}

	setPaymentMethod(ccinfo, pm, silent?) {
		if (!this.checkPaymentClick('pm', pm, ccinfo, silent)) return;
		if (this.maxCreditPayment && pm.paymentType == 'creditCard' && this.cache.grandTotalPlusTip > this.maxCreditPayment) {
			return this.alertMaxCreditPayment();
		}
		delete this.$storage.wallet?.ccinfo;
		this.step = 'alternatePayment';

		this.missingPM = false;
		ccinfo.caption = pm.name;
        ccinfo.paymentMethod = pm.paymentType;
		ccinfo.account = pm._id;
		ccinfo.requireIdPhoneTrans = pm.requireIdPhoneTrans;
		ccinfo.merchantNumber = pm.merchantNumber;
		ccinfo.$$isExternal = pm.isExternal;
		ccinfo.paymentVerificationStrategy = _.get(pm, 'paymentVerificationStrategy', 'none');
		ccinfo.fullAddressRequired = pm.fullAddressRequired;
		ccinfo.zipCodeRequired = pm.zipCodeRequired;

		if ((["creditCard", "Cibus", "10bis"]).indexOf(pm.paymentType) == -1) {
			if (pm.paymentType == 'giftCard') this.checkGiftCardAccount(ccinfo);
			this.enableSaveToWallet = false;
			this.ui.updatePaymentInfo = false;
		} else {
			this.enableSaveToWallet = true;
		}
        // Apple/Google Pay logic
        if ((["creditGuard", "CreditGuard"]).includes(pm.paymentType) && pm.providerInfo) {
            ccinfo.providerInfo = pm.providerInfo;
        }
	}

	checkGiftCardAccount(ccinfo) {
		let _acc:any = _.find(this.ui.paymentMethods, { paymentType: "giftCard" });
		if (!_acc) return;
		let pm: any = _.find(_acc.accounts, { _id: ccinfo.account });
		if (pm) ccinfo.loyaltyApiKey = pm.loyaltyApiKey
	}

	checkWalletPaymentByAccount(pm, silent?) {
		if (!this.checkPreviusPayments(pm, silent)) return;
		let account = _.find(this.ui.paymentMethods, { _id: pm.account });
		return this.checkPayment(account, silent)
	}

	checkPayment(account, silent?) {
		if (!this.hasGratuity || account.enableGratuity) return true;
		if (!silent) {
			let message = this.appService.translate("MESSAGES.GRATUITY_NOT_ALLOWED_FOR_PM", { pm: account.name });
			this.appService.alert({ content: message, "confirmText": "GOT_IT" }).then(res => {}).catch(err => { });
		}
		return false;
	}

	checkPaymentClick(source, account, ccinfo?, silent?) {
		if (!this.hasGratuity || account.enableGratuity) return true;
		if (silent) return false;
		if (!this.cache.balanceDue) return this.checkPayment(account);

		let message = this.appService.translate("MESSAGES.GRATUITY_NOT_ALLOWED_FOR_PM", { pm: account.name });
		this.appService.confirm({
			content: message,
			confirmText: 'SELECT_ALTERNATE_PYMENT',
			cancelText: 'CONTINUE_WITHOUT_GRATUITY',
		}).then(res => {

		}).catch(err => {
			this.hasGratuity = false;
			this.cache.gratuity = this.$storage.order.gratuity = { amount: 0, type: 'm' };
			this.tabitPayService.fixGratuity();
			this.cache.grandTotalPlusTip = this.$storage.order.grandTotalPlusTip;
			if (source == 'pm') this.setPaymentMethod(ccinfo, account);
		});

		return false;
	}

	// --------------------------------------------------------------------->

	checkPreviusPayments(_ccinfo?, silent?) {
		let last4;
		if (!this.maxCreditPayment) return true;
		if (this.step == 'alternatePayment') {
			if (this.ccinfo.paymentMethod != 'creditCard') return true;
			last4 = this.ccinfo.pan.substr(this.ccinfo.pan.length - 4);
		} else {
			const ccinfo = _ccinfo ? _ccinfo : this.$storage.wallet.ccinfo;
			if (ccinfo.paymentType != 'creditCard') return true;
			last4 = ccinfo.displayPan;
		}
		let previousSameCardPatments = this.cache.grandTotalPlusTip;
		_.each(_.get(this.$storage, 'order.printData.collections.PAYMENT_LIST', []), pm => {
			if (pm.P_TENDER_TYPE == "creditCard" && pm.LAST_4 == last4) {
				previousSameCardPatments += pm.P_AMOUNT;
			}
		});
		if (previousSameCardPatments > this.maxCreditPayment) {
			if (!silent)this.alertMaxCreditPayment();
			return false;
		}
		return true;
	}

    manualSubmit(from?) {
        //this.paymentForm.onSubmit(undefined);
        this.submitContinue(from);
    }

	submit(form, ev?) {

		if (!this.appService.user && this.ccinfo.paymentMethod != 'Meshulam') {
			if (!this.phoneForm.valid) {
				this.phoneForm.get("phone").markAsTouched({ onlySelf: true });
				return;
			} else {
				const phone = this.phoneForm.value.phone;
				if (!this.appService.isValidMobilePhone(phone)) return;
				localStorage.setItem('c_phone', phone);
				this.$storage.contact.phone = phone;
			}
		}

		if (this.closing) return;
		if (this.step == 'alternatePayment' && !this.ccinfo.paymentMethod) {
			this.missingPM = true;
			return;
		}
		if (!form.valid || (_.get(this.ccinfo, 'paymentVerificationStrategy') == 'fullAddress' && !this.ccinfo.state && !['Stripe', 'AuthorizeNet'].includes(this.ccinfo.paymentMethod))) return;
		if (!this.checkPreviusPayments()) return;
		if (!this.appService.user && !this.$storage.contact.contractApprove) {
			this.appService.confirm({
				content: 'MESSAGES.DO_YOU_APPROVE_CONTRACT',
				confirmText: 'yes',
				cancelText: 'no',
				enlargeTextButtons: true
			}).then(res => {
				this.$storage.contact.contractApprove = true;
				this.submitContinue();
			}).catch(err => { });
		} else {
			this.submitContinue();
		}
	}

	submitContinue(from?) {
		delete window['LAST_PAYMENT_AMOUNT'];

        let that = this;
        let args: any = { gratuityAmount: this.$storage.order.gratuityAmount };

        // check if the site is closed
        var partialAmount;

        if (this.$storage.order.isPartialPayment) {
            args.isPartialPayment = true;
            partialAmount = this.$storage.order.grandTotalPlusTip;
        };

        this.$storage.order.$ccinfo = null;

		let amount = this.appService.parseCurrency(this.cache.grandTotalPlusTip);
		that.appService.cachedPaymentInfo = null;
		this.appService.cacheContact = this.$storage.contact;

		if (that.step == 'alternatePayment') {
			this.appService.trackData('payment click', { from: from, loggedIn: this.appService.user != null, wallet: false });

			if (!this.appService.user && this.$storage.contact.firstName) {
				this.$storage.contact.name = this.$storage.contact.firstName;
				localStorage.setItem('c_name', this.$storage.contact.name);
			} else if (from) {
				this.$storage.contact.name = from;
			}

			return that.generalUtils.checkForSignature(this.$storage, that.ccinfo)
            .then(() => {
				args.ccinfo = that.ccinfo;
				if (partialAmount) args.ccinfo.amount = partialAmount;
				args.alternatePayment = true;
				that.paying = true;

				if (that.ccinfo.paymentMethod == 'Braintree') {
					return this.expayService.initBraintree(this.$storage.customPaymentAccount, this.cache.grandTotalPlusTip)
                    .then(res => {
						if (!res) throw ({});
						args.ccinfo.nonce = res["nonce"];
						args.ccinfo.deviceData = res["deviceData"];
						that.appService.startBlock({ text: "PERFORMING_PAYMENT", class: 'dark-block' });
						that.tabitPayService.processPayment(args).then(handlePaySuccess, handlePayFail);
					}).catch(err => {
						that.paying = false;
					})
				} else {
					if (that.enableSaveToWallet) {
						that.appService.cachedPaymentInfo = that.generalUtils.ccInfoToWalletPayment(that.ccinfo);
						that.$storage.order.$ccinfo = that.ccinfo;
						if (that.ui.updatePaymentInfo) { args.updatePaymentInfo = true; };
					}
					that.appService.startBlock({ text: "PERFORMING_PAYMENT", class: 'dark-block' });
					return that.tabitPayService.processPayment(args).then(res => { handlePaySuccess(that.ccinfo, res) }, handlePayFail);
				}
			});
		} else {
			this.appService.trackData('payment click', { from: 'wallet', loggedIn: this.appService.user != null, wallet: true });
            const ccinfo = _.cloneDeep(that.$storage.wallet.ccinfo);
			return that.generalUtils.checkForIdCard(ccinfo)
            .then(() => {
                const ccdetails = _.get(that, 'ccinfo.customerDetails');
                if (ccdetails) ccinfo.customerDetails = ccdetails;
                if (partialAmount) ccinfo.amount = partialAmount;

				that.appService.startBlock({ text: "PERFORMING_PAYMENT", class: 'dark-block' });
				return that.generalUtils.checkForSignature(that.$storage, ccinfo)
				.then(() => {
					if (ccinfo.walletPayment && ['creditCard', 'CreditGuard', 'creditGuard'].includes(ccinfo.paymentType)) {
						// For wallet payment the account is selected as the wallet payment id
						ccinfo.walletPaymentMethodId = ccinfo.walletPayment;
						ccinfo.paymentType = 'CreditGuard';
					}
					args.ccinfo = ccinfo;
					that.paying = true;
					that.tabitPayService.processPayment(args)
					.then(res => { handlePaySuccess(ccinfo, res) }, handlePayFail);
                });
            });
        }

		function handlePaySuccess(_ccinfo?, resultOrder?) {
			that.closing = true;
			that.appService.stopBlock({ class: 'dark-block' });
			that.$storage.wasPayment = true;
			if (!_ccinfo) that.appService.animDialog({ title: 'MESSAGES.PAYMENT_ACCEPTED_SUCCESSFULLY', animation: 'check' });
			else {
				if (window['LAST_PAYMENT_AMOUNT']) {
					let paymentAmount = Number(window['LAST_PAYMENT_AMOUNT']) / 100;
					amount = that.appService.parseCurrency(paymentAmount);
				}
				that.dialogsService.showPaySuccessDialogs({
					$storage: that.$storage,
					ccinfo: _ccinfo,
					amount: amount,
					gratuity: that.$storage.order.gratuity,
					resultOrder: resultOrder
				});
			}

			that.onPayment.emit({ amount: amount, showMessage: false });
			that.appService.sendAnalyticsEvent('purchase', {
				'transaction_id': that.$storage.order._id,
				'value': amount,
				'currency': that.appService.currency
			});
        }

		function handlePayFail(args) {
			that.showPaymentTypes = true;
			that.appService.stopBlock({ class: 'dark-block' });
            if (args.phone) {
				that.generalUtils.showMessageWithPhone(args.message, args.phone)
                .then(() => {
                    if (args.orderClosed) {
                        handlePaySuccess();
                    }
                });
            } else {
				if (args.type == 'CANCELED') {
                    // Show payments after Apple/Google pay request
                    that.showPaymentTypes = true;
                    return;
                }
				if (args.code && !args.wasErrorDesc) {
					let _message = that.appService.getErrorCodeTrans(args.code);
					if (_message) args.message = _message;
				}
                that.appService.alert({ content: args.message }).then(() => {
                    if (args.orderClosed) {
                        handlePaySuccess();
					}
					if (args.code == '20106') {
						that.onPayment.emit({});
					}
                });
            }
        }
    }

    // Native Payments (Apple/Google pay)

    appendApplePayButton(className: string) {
        const payButton = document.createElement('apple-pay-button');
        // Add any desired attributes or classes to the button
        payButton.setAttribute('buttonstyle', 'white-outline');
        payButton.setAttribute('type', 'plain');
        payButton.setAttribute('locale', 'en-US');
        payButton.addEventListener('click', this.initApplePaymentRequest.bind(this));
        const append = () => document.querySelector(className)?.appendChild(payButton);
        if (document.readyState !== 'loading') append();
        else document.addEventListener('DOMContentLoaded', append);
    }

    initApplePaymentRequest() {
        const amount = this.cache.grandTotalPlusTip;
        const sessionData = {
            amount,
            $storage :this.$storage,
        };
        this.showPaymentTypes = false;
        this.expayService.initApplePaymentRequest(sessionData)
			.then((token: any) => {

            if (!token) {
                this.showPaymentTypes = true;
                return;
            };
            const stringifiedToken = JSON.stringify(token);
            const cgAccount = this.$storage.paymentAccounts.find(account => account.paymentType == 'CreditGuard');
            if (!cgAccount) throw 'No valid payment account';

            // Needed to disctruct in order to zeroize the memory ref
            const freshAccount = {
                ...cgAccount
            };

            freshAccount.providerInfo = {
                "applePay": {
                    token: stringifiedToken
                },
            };
            this.setPaymentMethod(this.ccinfo, freshAccount);
            this.manualSubmit("Apple Pay");
        }).catch(err => {
            this.showPaymentTypes = true;
            console.error(err);
            this.expayService.handleNativePaymentError();
        });
    }

    initGooglePaymentRequest() {
        try {
            const amount = this.cache.grandTotalPlusTip;
            const cgAccount = this.$storage.paymentAccounts.find(account => account.paymentType == 'CreditGuard');
            if (!cgAccount) throw 'No valid payment account';

            // Needed to disctruct in order to zeroize the memory ref
            const freshAccount = {
                ...cgAccount
            };

            const sessionData = {
                amount,
                account: freshAccount,
                $storage: this.$storage
            };
            try {
                this.expayService.initGooglePayPayment(sessionData)
                .then(token => {
                    freshAccount.providerInfo = {
                        "googlePay": {
                            token
                        },
                    };
                    this.showPaymentTypes = false;
                    this.setPaymentMethod(this.ccinfo, freshAccount);
                    this.manualSubmit("Google Pay");
                }).catch(err => {
                    this.showPaymentTypes = true;
                    throw err;
                });
            } catch(err) {
                this.showPaymentTypes = true;
                console.error(err);
                this.expayService.handleNativePaymentError();
            }
        } catch(err) {
            this.showPaymentTypes = true;
            this.expayService.handleNativePaymentError();
        }
    }

    get getDefaultCCinfo() {
        return { type: undefined };
	}

}






